import { TaskItem } from '../../../core';
import { ViewTaskItem } from '../model/view-task-item.model';

import {
    IMPORTANCE_HIGH,
    IMPORTANCE_NORMAL,
    STATUS_COMPLETED,
    STATUS_NOT_STARTED,
} from './view-task-item.transformer';

export function taskItemTransformer(tasks: ViewTaskItem[]): TaskItem[] {
    return tasks.map<TaskItem>((e) => ({
        msftTaskId: e.msftTaskId,
        title: e.title,
        importance: e.important === true ? IMPORTANCE_HIGH : IMPORTANCE_NORMAL,
        status: e.completed === true ? STATUS_COMPLETED : STATUS_NOT_STARTED,
        createdDateTime: e.createdDateTime,
        dueDateTime: e.dueDateTime,
    }));
}
